module.exports = __webpack_public_path__ + "static/media/certify-edit.36ba92a8.png";